import Vue from "vue";

// Vue 3 migration: replace with mitt()
export const bus = new Vue();
